// @/app/(protected)/providers.tsx
"use client";

import * as React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import AppTheme from "@/styles/AppTheme";
import { SyntaxHighlightThemeProvider } from "@/styles/syntaxHighlightTheme";

export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <AppTheme>
      <CssBaseline enableColorScheme />
      <SyntaxHighlightThemeProvider>{children}</SyntaxHighlightThemeProvider>
    </AppTheme>
  );
}
